import { render, staticRenderFns } from "./zrecord.vue?vue&type=template&id=7a9685b8&scoped=true&lang=html&"
import script from "./zrecord.vue?vue&type=script&lang=js&"
export * from "./zrecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a9685b8",
  null
  
)

export default component.exports